import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { fetchOrgInfo, fetchOrgMembers, fetchOrgCredits, fetchPendingInvites } from '../../api/orgService';

import { orgKeys } from './keys';

export const orgInfoOptions = () =>
	queryOptions({
		queryKey: orgKeys.info(),
		queryFn: () => fetchOrgInfo(),
		staleTime: STALE_TIMES.STANDARD,
		retry: 2,
	});

export const orgMembersOptions = (orgRole) =>
	queryOptions({
		queryKey: orgKeys.members(),
		queryFn: () => fetchOrgMembers(),
		staleTime: STALE_TIMES.STANDARD,
		retry: 2,
		enabled: orgRole === 'owner' || orgRole === 'admin',
	});

export const orgCreditsOptions = (orgRole) =>
	queryOptions({
		queryKey: orgKeys.credits(),
		queryFn: () => fetchOrgCredits(),
		staleTime: STALE_TIMES.STANDARD,
		retry: 2,
		enabled: orgRole === 'owner' || orgRole === 'admin',
	});

export function useOrgInfo() {
	return useQuery(orgInfoOptions());
}

export function useOrgMembers(orgRole) {
	return useQuery(orgMembersOptions(orgRole));
}

export const orgMembersBasicOptions = () =>
	queryOptions({
		queryKey: orgKeys.membersBasic(),
		queryFn: () => fetchOrgMembers(),
		staleTime: STALE_TIMES.STANDARD,
	});

export function useOrgMembersBasic() {
	return useQuery(orgMembersBasicOptions());
}

export function useOrgCredits(orgRole) {
	return useQuery(orgCreditsOptions(orgRole));
}

export const pendingInvitesOptions = (enabled) =>
	queryOptions({
		queryKey: orgKeys.pendingInvites(),
		queryFn: async () => {
			const res = await fetchPendingInvites();
			return res.invites ?? [];
		},
		staleTime: STALE_TIMES.FREQUENT,
		retry: 1,
		enabled: Boolean(enabled),
	});

export function usePendingInvites(enabled) {
	return useQuery(pendingInvitesOptions(enabled));
}
